import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import store from 'reduxStore'
import App from './App.tsx'
import './assets/styles/styles.scss'
import ErrorPage from './pages/ErrorPage'
import { ModalProvider } from 'contexts/ModalContext'
import CrashPage from 'pages/CrashPage'
import { reloadOnStaleChunk, startVersionPolling } from './utils/versionCheck';

reloadOnStaleChunk();
startVersionPolling();

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <ErrorPage
      fallback={
      <CrashPage/>
      }
    >
      <ModalProvider>
        <App />
      </ModalProvider>
    </ErrorPage>
  </Provider>,
)
